// extracted by mini-css-extract-plugin
export default {"newsFeed":"TipsAndDocsNewsfeed_newsFeed__TkQch","newsFeedMobile":"TipsAndDocsNewsfeed_newsFeedMobile__ap4v-","newsItem":"TipsAndDocsNewsfeed_newsItem__H8ZWf"};